import { render, staticRenderFns } from "./SGPFormToggleComponent.vue?vue&type=template&id=1f139890&scoped=true"
import script from "./SGPFormToggleComponent.vue?vue&type=script&lang=js"
export * from "./SGPFormToggleComponent.vue?vue&type=script&lang=js"
import style0 from "./SGPFormToggleComponent.vue?vue&type=style&index=0&id=1f139890&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f139890",
  null
  
)

export default component.exports